export interface Color {
  Name: string;
  HexCode: string; // #FFFFFF
  Type: string; // primary, secondary, etc.
}

enum BackgroundPreference {}
// Define enum values for BackgroundPreference if available

enum FontTextAssetType {
  ShortHeadline = 0,
  LongHeadline = 1,
  Description = 2,
  CallToAction = 3,
  // Add other text asset types as needed
}

enum Fontface {
  Arial = 0,
  NewTimesRoman = 1,
  // Add other font faces as needed
}


enum CropType {
  ManualCrop,
  CenterCrop,
  SmartCrop,
  Unknown,
}
export interface Asset {
  Id: number;
  Name: string;
  Src?: string;
  Type: string;
}

export interface Images extends Asset {
  BackgroundPreference?: BackgroundPreference;
  CropHeight: number;
  CropWidth: number;
  CropX: number;
  CropY: number;
  Url: string;
  ThumbnailUrl: string,
  SubType: string; // subtype used to distinguish logo or image?
  TargetHeight: number;
  TargetWidth: number;
  ImageType?: string; // square or landscape
}

export interface Font {
  Typeface: Fontface;
  Weight?: string;
  TextType: FontTextAssetType; // ad component that font will be applied to
}

export interface CropSettings {
  SourceX: number;
  SourceY: number;
  SourceWidth: number;
  SourceHeight: number;
  CroppingType?: CropType; // ManualCrop/CenterCrop/SmartCrop/Unknown
}

export interface BrandKitDataType {
  id: number;
  brandkitName: string;
  images?: Images[]; // Max 15
  logos?: Images[]; // Max 5
  palettes?: Color[]; // Max 5
  fonts?: Font[];
  squareLogosCount: number;
  landscapeLogosCount: number;
}
